function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeModal } from "@common/actions";
import ChannelLogo from "@common/components/ChannelLogo";
import { isEmpty } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
export var ChannelsModal = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ChannelsModal, Component);
    var _super = _create_super(ChannelsModal);
    function ChannelsModal(props) {
        _class_call_check(this, ChannelsModal);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            areLogosLoaded: false,
            channelLogos: null,
            subscriptionsPrismic: null
        };
        _this.renderChannels = _this.renderChannels.bind(_assert_this_initialized(_this));
        _this.setLogosReady = _this.setLogosReady.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ChannelsModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.renderChannels();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Sets state that logos are loaded
     */ key: "setLogosReady",
            value: function setLogosReady() {
                this.setState({
                    areLogosLoaded: true
                });
            }
        },
        {
            /**
     * Render all channels available for this subscription
     * @returns {any[]}
     */ key: "renderChannels",
            value: function renderChannels() {
                var _this = this;
                var _subscription_metaData;
                var _this_props = this.props, subscription = _this_props.subscription, logos = _this_props.logos, addon = _this_props.addon;
                var firstIndex = -1;
                var lastIndex = -1;
                var channels = isEmpty(subscription) ? addon.metaData.channels : (_subscription_metaData = subscription.metaData) === null || _subscription_metaData === void 0 ? void 0 : _subscription_metaData.channels;
                var channelLogos = channels.map(function(subscriptionChannelId, index) {
                    var _subscription_metaData_exceptions, _subscription_metaData;
                    var currentChannelException = subscription === null || subscription === void 0 ? void 0 : (_subscription_metaData = subscription.metaData) === null || _subscription_metaData === void 0 ? void 0 : (_subscription_metaData_exceptions = _subscription_metaData.exceptions) === null || _subscription_metaData_exceptions === void 0 ? void 0 : _subscription_metaData_exceptions.channels[subscriptionChannelId];
                    if (currentChannelException && firstIndex === -1) {
                        firstIndex = index;
                    }
                    if (currentChannelException) {
                        lastIndex = index;
                    }
                    // non consecutive
                    // Check if next element is going to be on the next row
                    // Row elements are 15
                    if (firstIndex !== -1 && Math.abs(lastIndex - index) > 1 && currentChannelException) {
                        firstIndex = -1;
                    }
                    return /*#__PURE__*/ _jsx(ChannelLogo, {
                        hasName: false,
                        className: currentChannelException ? "channel-exception ".concat(firstIndex === index || index % 15 === 0 ? "first" : "", " ") : "",
                        channelLogo: currentChannelException ? undefined : logos[subscriptionChannelId],
                        channelLogoURL: currentChannelException === null || currentChannelException === void 0 ? void 0 : currentChannelException.logo,
                        channelName: currentChannelException === null || currentChannelException === void 0 ? void 0 : currentChannelException.name,
                        isCentered: true,
                        setLogosReady: index === channels.length - 1 ? _this.setLogosReady : null,
                        redirectToChannel: false,
                        isInSubscriptionPage: true
                    }, subscriptionChannelId);
                });
                this.setState({
                    channelLogos: channelLogos
                });
            }
        },
        {
            /**
     *  Render footer with expections for the specific plan
     */ key: "renderFooter",
            value: function renderFooter() {
                var _subscription_metaData_exceptions, _subscription_metaData;
                var _this_props = this.props, subscription = _this_props.subscription, i18n = _this_props.i18n;
                var channelExceptionDescription = subscription === null || subscription === void 0 ? void 0 : (_subscription_metaData = subscription.metaData) === null || _subscription_metaData === void 0 ? void 0 : (_subscription_metaData_exceptions = _subscription_metaData.exceptions) === null || _subscription_metaData_exceptions === void 0 ? void 0 : _subscription_metaData_exceptions.description;
                if (channelExceptionDescription) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "channel-exception-footer",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "/common/assets/media/channel-exception.svg"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: channelExceptionDescription
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _subscriptionsPrismic_plans_items, _subscriptionsPrismic_r_addons_items, _currentModalPrismic_title;
                var _this_props = this.props, i18n = _this_props.i18n, subscription = _this_props.subscription, _$closeModal = _this_props.closeModal, addon = _this_props.addon, prismic = _this_props.prismic;
                var subscriptionsPrismic = prismic === null || prismic === void 0 ? void 0 : prismic.subscriptions;
                var wrapperClass = !this.state.areLogosLoaded ? " hidden" : "";
                var subscriptionPrismic = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_items = subscriptionsPrismic.plans_items) === null || _subscriptionsPrismic_plans_items === void 0 ? void 0 : _subscriptionsPrismic_plans_items.find(function(planItem) {
                    return planItem.id === (subscription === null || subscription === void 0 ? void 0 : subscription.id);
                });
                var addonPrismic = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_items = subscriptionsPrismic.r_addons_items) === null || _subscriptionsPrismic_r_addons_items === void 0 ? void 0 : _subscriptionsPrismic_r_addons_items.find(function(addonItem) {
                    return addonItem.id === (addon === null || addon === void 0 ? void 0 : addon.id);
                });
                var currentModalPrismic = !isEmpty(subscription) ? subscriptionPrismic : addonPrismic;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "modal channels-modal-wrapper".concat(wrapperClass),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "modal-title",
                                    children: i18n.order.channelsPopupTitle
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    onClick: _$closeModal,
                                    className: "icon icon-clear pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "subscription-type",
                            children: currentModalPrismic === null || currentModalPrismic === void 0 ? void 0 : (_currentModalPrismic_title = currentModalPrismic.title) === null || _currentModalPrismic_title === void 0 ? void 0 : _currentModalPrismic_title.text
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                maxHeight: "-webkit-fill-available",
                                overflow: "auto"
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "modal-content",
                                    children: this.state.channelLogos
                                }),
                                this.renderFooter()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ChannelsModal;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, prismic = param.prismic;
    return {
        i18n: i18n,
        prismic: prismic
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal
})(ChannelsModal);
